import {
  Box,
  Button,
  ButtonGroup,
  Divider,
  Paper,
  Stack,
  Typography,
} from '@mui/material'
import { tsAnimal } from '../../../../Typescript/DB_Interface'
import AnimalButton from '../Buttons/AnimalButton'
import { tsAddAnimal, tsStorageAnimalMeta } from '../ValidSamplesState'
import { Add } from '@mui/icons-material'
import StorageSample from './StorageSample'
import { useAddSampleContext } from '../../../../Contexts/Modules/SampleModule/AddSampleModule'

/**
 * Card that contains multiple storage samples for an animal (qty === 'multiple').
 * Allows adding more samples and carries forward selected metadata for convenience.
 */
function StorageCard({
  animal,
  setAnimals,
  animals,
  animalIndex,
  onSampleEnterTab,
  containerMeta,
}: {
  animal: Partial<tsAnimal>
  setAnimals: any
  animals: tsAddAnimal
  animalIndex: number
  onSampleEnterTab?: any
  containerMeta?: Partial<tsStorageAnimalMeta>
}) {
  const { sampleRun } = useAddSampleContext()
  const isRunType570 = sampleRun?.runInfo?.RunType === '570' || false
  const uai = animal.UAI!
  return (
    <Paper
      elevation={3}
      key={animal.UAI}
      sx={{ width: 1, p: 2, display: 'flex' }}
    >
      <Stack
        gap={1.5}
        width={1}
      >
        <Stack
          direction={'row'}
          gap={1}
          width={1}
        >
          <AnimalButton animal={animal} />
          <ButtonGroup
            sx={{ width: 60 }}
            orientation={'vertical'}
          >
            <Button disabled={true}>{animals[uai]?.length}</Button>
            <Button
              tabIndex={-1}
              color={'success'}
              onClick={() => {
                setAnimals((a: any) => {
                  let metadata: Partial<tsStorageAnimalMeta>
                  if (isRunType570) {
                    metadata = {
                      NumSamples: a[uai]?.[0]?.metadata?.NumSamples || '',
                      FreezingMethod: a[uai]?.[0]?.metadata?.FreezingMethod,
                    }
                  } else {
                    // For other RunTypes (e.g. 550), include the original fields
                    metadata = {
                      OrganType: a[uai]?.[0]?.metadata?.OrganType,
                      StorageMedia: a[uai]?.[0]?.metadata?.StorageMedia,
                      FreezingMethod: a[uai]?.[0]?.metadata?.FreezingMethod,
                      SampleDetails: a[uai]?.[0]?.metadata?.SampleDetails,
                      MethodEuthanasia: containerMeta?.MethodEuthanasia || '',
                    }
                  }

                  return {
                    ...a,
                    [uai]: [
                      ...a[uai],
                      {
                        sampleID: '',
                        // STU-1815 ...automatically select the same values on all remaining animals (and any subsequently added samples)
                        metadata,
                      },
                    ],
                  }
                })
              }}
            >
              <Add />
            </Button>
          </ButtonGroup>
        </Stack>
        {(animals[uai] ?? []).map((sample, index) => {
          return (
            <Box key={index}>
              <Divider sx={{ mx: -2, lineHeight: 0.5 }}>
                <Typography
                  variant={'caption'}
                  fontWeight={'bold'}
                >
                  {animals[uai][index]?.sampleID || 'New Sample'}
                </Typography>
              </Divider>
              <StorageSample
                animalIndex={animalIndex}
                sample={sample}
                uai={uai}
                animals={animals}
                setAnimals={setAnimals}
                sampleIndex={index}
                onSampleEnterTab={onSampleEnterTab}
              />
            </Box>
          )
        })}
      </Stack>
    </Paper>
  )
}

export default StorageCard
